import { IProject } from '../interface/IProject';
import { authenticatedApi } from './api';

const getAllProjects = async () => {
  return authenticatedApi.get('project/all');
};

const getProject = async (projectId: number) => {
  return authenticatedApi.get(`project/${projectId}`);
};

const createProject = async (projectInput: IProject) => {
  return authenticatedApi.post('project/create', projectInput);
};

const updateProject = async (projectId: number, projectInput: IProject) => {
  return authenticatedApi.put(`project/update/${projectId}`, projectInput);
};

const deleteProject = async (projectId: number) => {
  return authenticatedApi.delete(`project/delete/${projectId}`);
};

const projectApi = { getAllProjects, getProject, createProject, updateProject, deleteProject };

export default projectApi;
